import { Component, Input, Output, EventEmitter } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ScheduledRouteRecap } from '../../affair-pool-optimization.types'

/**
 * Récap de la tournée du jour d'un technicien, affiché en colonne de droite
 * lorsqu'on clique sur une intervention programmée sur la carte.
 * Affiche l'ordre des interventions et leurs horaires.
 */
@Component({
  selector: 'app-pool-scheduled-route-recap',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pool-scheduled-route-recap.component.html',
  styleUrl: './pool-scheduled-route-recap.component.scss',
})
export class PoolScheduledRouteRecapComponent {
  @Input({ required: true }) recap!: ScheduledRouteRecap
  @Input() loading = false

  @Output() closed = new EventEmitter<void>()
}
